var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMailBlack24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "20px",
    viewBox: "0 0 26 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6FBA1917-DE8B-4C6E-B979-B4DD0F590567_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Voucher---Options",
    transform: "translate(-79.000000, -54.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Mail_Black-24px",
    transform: "translate(80.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L24,0 L24,13.7647059 C24,16.0941176 22.1217391,18 19.826087,18 L4.17391304,18 C1.87826087,18 0,16.0941176 0,13.7647059 L0,0 Z",
    id: "Stroke-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "3.76521739 4.12352941 12 11.6470588 20.2869565 4.12352941"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailBlack24Px);
export default __webpack_public_path__ + "static/media/Icon_Mail_Black-24px.fa9c641ed74214b7501ead44a287aaff.svg";
export { ForwardRef as ReactComponent };